import svgPaths from "../imports/svg-bekksjq70a";

function Trainzilla({ variant }: { variant: 'primary' | 'white' | 'dark' }) {
  const solidColor = variant === 'white' ? '#ffffff' : 
                    variant === 'dark' ? '#1E1E1E' : '#1E1E1E';
  
  return (
    <div className="h-[17px] w-[136.905px]">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 137 17"
      >
        <g>
          {/* ZILLA letters (solid color) */}
          <path
            d={svgPaths.p295ba500}
            fill={solidColor}
          />
          <path
            d={svgPaths.p26a9d300}
            fill={solidColor}
          />
          <path
            d={svgPaths.p1b2ebb80}
            fill={solidColor}
          />
          <path
            d={svgPaths.p1ea4700}
            fill={solidColor}
          />
          <path
            d={svgPaths.p21d3f7c0}
            fill={solidColor}
          />
          
          {/* TRAIN letters (gradient) */}
          <path
            d={svgPaths.p98ea200}
            fill="url(#paint0_linear_header)"
          />
          <path
            d={svgPaths.p2d9c05f0}
            fill="url(#paint1_linear_header)"
          />
          <path
            d={svgPaths.pedf2800}
            fill="url(#paint2_linear_header)"
          />
          <path
            d={svgPaths.p24938880}
            fill="url(#paint3_linear_header)"
          />
          <path
            d={svgPaths.p1729dd00}
            fill="url(#paint4_linear_header)"
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_header"
            x1="68.4567"
            x2="68.4567"
            y1="-5.82408"
            y2="22.9028"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_header"
            x1="68.4566"
            x2="68.4566"
            y1="-5.82408"
            y2="22.9028"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint2_linear_header"
            x1="68.4567"
            x2="68.4567"
            y1="-5.82408"
            y2="22.9028"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint3_linear_header"
            x1="68.4566"
            x2="68.4566"
            y1="-5.82408"
            y2="22.9028"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint4_linear_header"
            x1="68.4566"
            x2="68.4566"
            y1="-5.82405"
            y2="22.9028"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

function Group3() {
  return (
    <div className="h-[23.873px] w-[39.075px]">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 40 24"
      >
        <g>
          <path
            d={svgPaths.p3b72ed00}
            fill="url(#paint0_linear_group3)"
          />
          <path
            d={svgPaths.p3cf4ff40}
            fill="url(#paint1_linear_group3)"
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_group3"
            x1="15.5174"
            x2="15.5174"
            y1="5.6538"
            y2="23.8729"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_group3"
            x1="35.4922"
            x2="24.6059"
            y1="2.96711"
            y2="16.1121"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

function Group4() {
  return (
    <div className="h-[21.765px] w-[39.075px]">
      <svg
        className="block size-full"
        fill="none"
        preserveAspectRatio="none"
        viewBox="0 0 40 22"
      >
        <g>
          <path
            d={svgPaths.p11e56d80}
            fill="url(#paint0_linear_group4)"
          />
          <path
            d={svgPaths.p3554cb00}
            fill="url(#paint1_linear_group4)"
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint0_linear_group4"
            x1="21.8713"
            x2="21.8713"
            y1="19.7324"
            y2="1.33514e-05"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="paint1_linear_group4"
            x1="3.07207"
            x2="11.8653"
            y1="19.2255"
            y2="8.59023"
          >
            <stop stopColor="#6D92FF" />
            <stop offset="1" stopColor="#9516FA" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
}

function GeometricIcon() {
  return (
    <div className="flex flex-col gap-0.5 items-center justify-center w-12 h-12">
      <Group3 />
      <Group4 />
    </div>
  );
}

interface TrainZillaHeaderLogoProps {
  variant?: 'primary' | 'white' | 'dark';
  className?: string;
}

export default function TrainZillaHeaderLogo({ 
  variant = 'primary',
  className = '' 
}: TrainZillaHeaderLogoProps) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <GeometricIcon />
      <Trainzilla variant={variant} />
    </div>
  );
}
